import sharedConstants from "../constants";
import {
  Badge,
  BusinessDayType,
  DayOffDay,
  DayOffWeek,
  DefaultType,
  DeviceType,
  DispatchTemplateType,
  InquiryStatus,
  ProductPaymentType,
  RepairStatus,
  ReservationInterval,
  RoutineType,
  Service,
  TaxType,
} from "../enums";
import { Option } from "../interface";

export const timeArray = (): Option[] => {
  const array: Option[] = [];
  for (let i = 0; i < 24; i += 1) {
    const value =
      (i + 1).toString().length === 1
        ? `0${(i + 1).toString()}-00`
        : `${(i + 1).toString()}-00`;
    const newDate = new Date();
    newDate.setFullYear(2010);
    newDate.setMonth(2);
    newDate.setDate(1);
    newDate.setHours(Number(value.split("-")[0]) + 9);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    array.push({
      value: newDate.toISOString(),
      label:
        (i + 1).toString().length === 1
          ? `0${(i + 1).toString()}:00`
          : `${(i + 1).toString()}:00`,
    });
  }
  return array;
};
export const numberArray = (value: number, exclude?: number[]): Option[] => {
  const array: Option[] = [];
  for (let i = 0; i < value; i += 1) {
    if (!exclude?.includes(i + 1))
      array.push({ value: i + 1, label: (i + 1).toString() });
  }
  return array;
};
export const badgeArray = [
  { label: "우수", value: Badge.GREAT },
  { label: "보통", value: Badge.NORMAL },
  { label: "미흡", value: Badge.BAD },
];
export const viewableArray: Option[] = [
  {
    label: "전체",
    value: DefaultType.ALL,
  },
  {
    label: "노출",
    value: true,
  },
  {
    label: "미노출",
    value: false,
  },
];
const TEXT_OPTIONAL_TRUE = "선택";
const TEXT_OPTIONAL_FALSE = "필수";

export const possibleArray: Option[] = [
  { label: "가능", value: true },
  { label: "불가능", value: false },
];
export const optionableArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: TEXT_OPTIONAL_TRUE, value: true },
  { label: TEXT_OPTIONAL_FALSE, value: false },
];
export const onlyOptionableArray: Option[] = [
  { label: TEXT_OPTIONAL_TRUE, value: true },
  { label: TEXT_OPTIONAL_FALSE, value: false },
];
export const onlyViewableArray: Option[] = [
  { label: "노출", value: true },
  { label: "미노출", value: false },
];

export const onlyPlatformArray: Option[] = [
  { label: "ios", value: DeviceType.IOS },
  { label: "android", value: DeviceType.ANDROID },
];

export const inquiryStatusArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "답변대기", value: InquiryStatus.PENDING },
  { label: "접수완료", value: InquiryStatus.RECEIVED },
  { label: "답변완료", value: InquiryStatus.REPLIED },
];

export const faqArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "차량관리", value: "차량관리" },
  { label: "회원", value: "회원" },
  { label: "주문/결제", value: "주문/결제" },
  { label: "쿠폰/프로모션", value: "쿠폰/프로모션" },
  { label: "교환/환불", value: "교환/환불" },
  { label: "정산", value: "정산" },
  { label: "반품/배송", value: "반품/배송" },
  { label: "주문현황", value: "주문현황" },
  { label: "기타", value: "기타" },
];
export const onlyFaqArray: Option[] = [
  { label: "차량관리", value: "차량관리" },
  { label: "회원", value: "회원" },
  { label: "주문/결제", value: "주문/결제" },
  { label: "쿠폰/프로모션", value: "쿠폰/프로모션" },
  { label: "교환/환불", value: "교환/환불" },
  { label: "정산", value: "정산" },
  { label: "반품/배송", value: "반품/배송" },
  { label: "주문현황", value: "주문현황" },
  { label: "기타", value: "기타" },
];
export const customerFaqArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "회원", value: "회원" },
  { label: "주문/결제", value: "주문/결제" },
  { label: "쿠폰/프로모션", value: "쿠폰/프로모션" },
  { label: "교환/환불", value: "교환/환불" },

  { label: "기타", value: "기타" },
];
export const repairShopFaqArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "회원", value: "회원" },
  { label: "정산", value: "정산" },
  { label: "반품/배송", value: "반품/배송" },
  { label: "주문현황", value: "주문현황" },
  { label: "기타", value: "기타" },
];
export const onlyCustomerFaqArray: Option[] = [
  { label: "회원", value: "회원" },
  { label: "주문/결제", value: "주문/결제" },
  { label: "쿠폰/프로모션", value: "쿠폰/프로모션" },
  { label: "교환/환불", value: "교환/환불" },
  { label: "기타", value: "기타" },
];
export const onlyRepairShopFaqArray: Option[] = [
  { label: "회원", value: "회원" },
  { label: "정산", value: "정산" },
  { label: "반품/배송", value: "반품/배송" },
  { label: "주문현황", value: "주문현황" },
  { label: "기타", value: "기타" },
];
export const applyStatusArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "신청", value: "신청" },
  { label: "승인", value: "승인" },
  { label: "반려", value: "반려" },
];
export const inventoryStatusArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "있음", value: "있음" },
  { label: "없음", value: "없음" },
];

export const notificationArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
  { label: "이메일", value: "email" },
  { label: "문자", value: "message" },
  { label: "푸쉬", value: "push" },
];
export const onlyNotificationArray: Option[] = [
  { label: "이메일", value: "email" },
  { label: "문자", value: "message" },
  { label: "푸쉬", value: "push" },
];
export const stockArray: Option[] = [{ label: "전체", value: DefaultType.ALL }];
export const deliveryMethodArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
];
export const returnMethodArray: Option[] = [
  { label: "전체", value: DefaultType.ALL },
];
export const dayArray: Option[] = [
  { label: "월요일", value: "월요일" },
  { label: "화요일", value: "화요일" },
  { label: "수요일", value: "수요일" },
  { label: "목요일", value: "목요일" },
  { label: "금요일", value: "금요일" },
  { label: "토요일", value: "토요일" },
  { label: "일요일", value: "일요일" },
];
export const holidayArray = [
  { label: "명절", value: "명절" },
  { label: "그외 공휴일", value: "그외 공휴일" },
  { label: "대체 공휴일", value: "대체 공휴일" },
];
export const soldOutArray: Option[] = [
  { label: "전체", value: "" },
  { label: "품절", value: true },
  { label: "품절아님", value: false },
];
export const onlySoldOutArray: Option[] = [
  { label: "재고있음", value: true },
  { label: "품절", value: false },
];

export const productPaymentTypeArray = [
  { label: "가상계좌", value: ProductPaymentType.VIRTUAL_ACCOUNT },
  { label: "카카오페이", value: ProductPaymentType.KAKAO },
  { label: "네이버페이", value: ProductPaymentType.NAVER },
  { label: "신용/체크", value: ProductPaymentType.CARD },
  { label: "토스", value: ProductPaymentType.TOSS },
];
export const taxTypeArray = [
  { label: "과세", value: TaxType.TAX },
  { label: "영세", value: TaxType.TAX_ZERO },
  { label: "면세", value: TaxType.TAX_FREE },
];
export const dispatchTemplateTypeArray = [
  { label: "전체", value: DispatchTemplateType.ALL },
  { label: "이메일", value: DispatchTemplateType.EMAIL },
  { label: "문자", value: DispatchTemplateType.MESSAGE },
  { label: "푸쉬", value: DispatchTemplateType.PUSH },
];
export const onlyDispatchTemplateTypeArray = [
  { label: "이메일", value: DispatchTemplateType.EMAIL },
  { label: "문자", value: DispatchTemplateType.MESSAGE },
  { label: "푸쉬", value: DispatchTemplateType.PUSH },
];

export const onlyReservationIntervalArray = [
  { label: "30분", value: ReservationInterval.THIRTY },
  { label: "1시간", value: ReservationInterval.SIXTY },
  { label: "1.5시간", value: ReservationInterval.NINETY },
  { label: "2시간", value: ReservationInterval.ONEHUNDREDTWENTY },
  { label: "2.5시간", value: ReservationInterval.ONEHUNDREDFIFTY },
  { label: "3시간", value: ReservationInterval.ONEHUNDREDEIGHTY },
];

export const businessDayTypeArray = [
  { label: "매일 같아요", value: BusinessDayType.EVERYDAY },
  { label: "평일/주말 달라요", value: BusinessDayType.WEEKDAY_WEEKEND },
  {
    label: "요일별로 달라요",
    value: BusinessDayType.DAY,
  },
];
export const weeksArray = [
  { label: "1", value: DayOffWeek.ONE },
  { label: "2", value: DayOffWeek.TWO },
  { label: "3", value: DayOffWeek.THREE },
  { label: "4", value: DayOffWeek.FOUR },
  { label: "5", value: DayOffWeek.FIVE },
];

export const daysArray = [
  { label: "월", value: DayOffDay.MONDAY },
  { label: "화", value: DayOffDay.TUESDAY },
  { label: "수", value: DayOffDay.WEDNESDAY },
  { label: "목", value: DayOffDay.THURSDAY },
  { label: "금", value: DayOffDay.FRIDAY },
  { label: "토", value: DayOffDay.SATURDAY },
  { label: "일", value: DayOffDay.SUNDAY },
];
export const hasRoutineRestArray = [
  { label: "휴무일이 있어요", value: true },
  { label: "휴무일이 없어요", value: false },
];
export const routineTypeArray = [
  { label: "매주 특정요일", value: RoutineType.EVERY_WEEK },
  {
    label: "매주는 아니에요",
    value: RoutineType.NOT_EVERY_WEEK,
  },
];
export const isEveryDayRestSameArray = [
  { label: "매일 같아요", value: BusinessDayType.EVERYDAY },
  { label: "평일/주말 달라요", value: BusinessDayType.WEEKDAY_WEEKEND },
  {
    label: "요일별로 달라요",
    value: BusinessDayType.DAY,
  },
];
export const isWorkAtHolidayArray = [
  { label: "공휴일 영업해요", value: true },
  {
    label: "공휴일 쉬어요",
    value: false,
  },
];
export const holidayAllArray = [{ label: "공휴일 전체", value: true }];

export const getHolidayArray = (): Option[] => {
  return sharedConstants.arrays.holidays.map((val) => {
    const returnValue: Option = {
      label: val,
      value: val,
    };
    return returnValue;
  });
};
export const yesOrNoArray = [
  { label: "예", value: true },
  { label: "아니오", value: false },
];
export const repairStatusArray = [
  { label: "예약신청", value: RepairStatus.PAYMENT_COMPLETED },
  {
    label: "예약확정",
    value: RepairStatus.RESERVATION_COMPLETED,
  },
  { label: "작업완료", value: RepairStatus.COMPLETED },
];
export const isDaySelectArray = [
  { label: "요일 별 설정 켜기", value: true },
  { label: "요일 별 설정 끄기", value: false },
];
